export default __webpack_public_path__ + "static/media/video_bg_section1_pc.da6ece7a.mp4";